/* ZZ Marts product page. Vanilla JS, no libraries, ~70 lines. */
(function () {
  'use strict';

  /* ---------- gallery ---------- */
  var gal = document.querySelector('[data-zz-gallery]');
  if (gal) {
    var slides = gal.querySelectorAll('[data-zz-slide]');
    var thumbs = gal.querySelectorAll('[data-zz-thumb]');
    var counter = gal.querySelector('[data-zz-count]');
    var idx = 0;

    function show(n) {
      if (!slides.length) return;
      idx = (n + slides.length) % slides.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () { show(parseInt(t.dataset.zzThumb, 10)); });
    });
    var prev = gal.querySelector('[data-zz-prev]');
    var next = gal.querySelector('[data-zz-next]');
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });

    /* swipe on touch devices */
    var x0 = null;
    var stage = gal.querySelector('.zzg__stage');
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
        x0 = null;
      }, { passive: true });
    }

    /* keyboard */
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* ---------- quantity ---------- */
  document.querySelectorAll('[data-zz-qty]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('input[name="quantity"]');
      if (!input) return;
      var next = parseInt(input.value, 10) + parseInt(btn.dataset.zzQty, 10);
      input.value = next < 1 ? 1 : next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- sticky add to cart ---------- */
  var bar = document.querySelector('[data-zz-sticky]');
  var atc = document.querySelector('[data-zz-atc]');
  if (bar && atc && 'IntersectionObserver' in window) {
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      /* show the bar only once the real button has scrolled out of view */
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -80px 0px' });
    io.observe(atc);

    var stickyBtn = bar.querySelector('[data-zz-sticky-add]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () { atc.click(); });
    }
  }
})();
